module.exports = __webpack_public_path__ + "static/img/iso5.1e415998.png";